import axios from 'axios';
import { API_URL } from '../config';
import { Justification } from '../types';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

export const getJustificationsList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/justifications/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
      return response.data;
  };
  
  export const getJustificationsCompanyList = async (token: string, permission: string | null, excludeAreaMarkers: boolean = false) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
        permission,
        params: {
          ...(excludeAreaMarkers && {
            exclude_area_markers: 'true',
          }),
        },
      } as CustomAxiosRequestConfig);
    return response.data;
  };
  
  export const getJustificationCompany = async (token: string, id?: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const deleteJustificationCompany = async (token: string, id: string | number) => {
    const response = await axios.delete(`${API_URL}/presenze/company/justifications/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const addJustificationCompany = async (token: string, justificationId: number) => {
    const response = await axios.post(`${API_URL}/presenze/company/justifications/`,
      {
        justification: justificationId,  
      },
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }

  export const updateJustificationCompany = async (token: string, justificationId: number, external_reference: string) => {
    const response = await axios.patch(`${API_URL}/presenze/company/justifications/${justificationId}/`,
      {
        external_reference,  
      },
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }


  export const addJustificationCustomCompany = async (token: string, justification: Justification) => {

    if(justification.rateo === null) {
      delete justification.rateo
    }

    const response = await axios.post(`${API_URL}/presenze/company/justifications/custom/`,
      justification 
      ,
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }

  export const getJustificationCustomCompanyList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/custom/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };


  export const getJustificationCustomCompany = async (token: string, id?: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/custom/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };

  export const deleteJustificationCustomCompany = async (token: string, id: string) => {
    const response = await axios.delete(`${API_URL}/presenze/company/justifications/custom/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };

  export const updateJustificationCustomCompany = async (token: string, id: number, justificationData: any) => {
    const response = await axios.put(`${API_URL}/presenze/company/justifications/custom/${id}/`,
      justificationData,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
  };


  export const addAreaMarker = async (token: string, justification: Justification) => {
    const payload = { ...justification };

    if (payload.rateo === null) {
      delete payload.rateo;
    }

    const response = await axios.post(`${API_URL}/presenze/company/area-markers/`, payload,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
    return response.data;
  };


  export const getAreaMarkerList = async (
    token: string,
    params?: {
      search?: string;
      page?: number;
      page_size?: number;
      paginate?: boolean;
    }
  ) => {
    const response = await axios.get(`${API_URL}/presenze/company/area-markers/`,
      {
        headers: {
          'Authorization': token,
        },
        params,
      }
    );

    return response.data;
  };


  export const getAreaMarker = async (token: string, id: string | number) => {
    const response = await axios.get(`${API_URL}/presenze/company/area-markers/${id}/`,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
    return response.data;
  };


  export const deleteAreaMarker = async (token: string, id: string | number) => {
    const response = await axios.delete(`${API_URL}/presenze/company/area-markers/${id}/`,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
    return response.data;
  };


  export const updateAreaMarker = async (token: string, id: string | number, justificationData: any) => {
    const response = await axios.put(`${API_URL}/presenze/company/area-markers/${id}/`,
      justificationData,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
    return response.data;
  };

  export const patchAreaMarker = async (token: string, id: string | number, justificationData: Partial<Justification>) => {
    const response = await axios.patch(`${API_URL}/presenze/company/area-markers/${id}/`, justificationData,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
  return response.data;
};

  export const updateJustificationTeamCalendarStatus = async (token: string, justificationId: number, team_calendar_status: string) => {
    const response = await axios.patch(`${API_URL}/presenze/company/justifications/${justificationId}/`,
      {
        team_calendar_status,
      },
      {
        headers: {
          'Authorization': `${token}`
        }
      }
    );
    return response.data;
  }
